import { getApiErrorMessage } from "../../../utils/ErrorUtils";

export const portalComplianceErrorMessage = (
  error: unknown,
  fallback: string,
): string => getApiErrorMessage(error, fallback);
